<template >
        <span class="bgrndinfo" :style="backgroundStyle">
<!--                 <div style="float: right; margin-top:23px;">
                <a href="/sample.html">
                <el-tooltip class="item" effect="dark" :content="$t('menu.samples')" placement="bottom" :hide-after="3000">
                <img src="../../static/images/muster.png" alt="StruViMan graphic"/></el-tooltip></a>
                </div> -->
    
                <div>
                <h2>StruViMan</h2>
                <h3>Structural Visualization of Manuscripts</h3>
                </div>
    
                <div>                  

                  <p>StruViMan est un outil disponible gratuitement pour obtenir un aperçu visuel de la structure des manuscrits. Les codex anciens sont des objets complexes et la disponibilité d'images numériques et/ou de métadonnées n'est souvent pas suffisante pour appréhender rapidement les propriétés structurelles. La dimension diachronique joue un rôle important (couches de production multiples, reconstruction des strates du passé). StruViMan peut décomposer la structure selon deux critères différents (par exemple, les unités de production, les éléments de contenu).</p>

                  <p>L'outil a été développé à la Ludwig-Maximilians-Universität de Munich dans le cadre du projet ERC "Paratexts of the Bible (ParaTexBib)". Il a été financé par une subvention pour la validation du concept (2017-2018, Grant No. 737621).</p>
    
                <p>L'outil est utilisé sur le site <a href="https://www.manuscripta-biblica.org" target="_blank">www.manuscripta-biblica.org</a> et sur le site <a href="https://pinakes.irht.cnrs.fr/" target="_blank">pinakes.irht.cnrs.fr/</a>. Il est ouvert à d'autres candidatures.</p>
                
                <p>À des fins de démonstration, une liste de manuscrits peut être trouvée <a href="/sample.html"> ici</a>.</p>

                <p>Les informations techniques d'utilisation se trouvent ci-dessous dans la rubrique "Information &amp; aide". Pour plus d'explications, voir l'article <a href="https://doi.org/10.1515/opth-2019-0009" target="_blank"> ici</a>.</p>
                
                </div>
              </span>
</template>

<script >

export default {
    name: 'VStartInfoEn',
    props: {
        backgroundStyle: {
            default: ''
        }
    }
}

</script>




// WEBPACK FOOTER //
// src/components/VStartInfoFr.vue